module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-LightItalic-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-LightItalic-webfont.woff
// module id = 1631
// module chunks = 0